/**
 * TARAYICI OTOMATİK DOLDURMASI KAPALI — 30 Ekim 2026, kullanıcı: «sistem genelinde autofill kapalı
 * olsun her şeyiyle, google safari her yerde».
 *
 * Görülen: sunum talebinin «Konu» alanında Safari başka bir talebin konusunu öneriyordu. Kitin
 * alanları `autocomplete` taşımıyor ve yüzlerce alanı tek tek değiştirmek yerine belge düzeyinde bir
 * gözcü var: sayfaya giren her `input`, `textarea`, `select` ve `form`a, kendi `autocomplete` değeri
 * YOKSA `off` yazılıyor.
 *
 * AÇIKÇA YAZILMIŞ DEĞER KALIYOR: giriş ve parola ekranlarındaki `username`, `current-password`,
 * `new-password`, `one-time-code` bilerek orada — parola yöneticisi ve tek kullanımlık kod onlarla
 * çalışıyor, ve tarayıcılar parola alanında `off`u zaten dinlemiyor.
 */
const FIELDS = "input, textarea, select, form";

export function markAutofillOff(root: ParentNode): void {
  if (root instanceof Element && root.matches(FIELDS) && !root.hasAttribute("autocomplete")) {
    root.setAttribute("autocomplete", "off");
  }
  for (const element of root.querySelectorAll(FIELDS)) {
    if (!element.hasAttribute("autocomplete")) element.setAttribute("autocomplete", "off");
  }
}

/** Belgeyi baştan işaretler ve sonradan eklenen alanları izler; dönen işlev izlemeyi durdurur. */
export function disableBrowserAutofill(doc: Document = document): () => void {
  markAutofillOff(doc);
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof Element) markAutofillOff(node);
      }
    }
  });
  observer.observe(doc.documentElement, { childList: true, subtree: true });
  return () => observer.disconnect();
}
